import { Flags, Permissions, SegFlags } from "../../common/providers";

export default ({ projectId, portfolioName }) => [
	{
		name: "navigation:project.dashboard",
		subItems: [
			{
				name: "navigation:project.project",
				to: `/projects/${projectId}/dashboard/project`,
				segFlag: SegFlags.PROJECT_SUMMARY_DASHBOARD,
			},
			{
				name: "navigation:project.my-progress",
				to: `/projects/${projectId}/dashboard/review-progress`,
				segFlag: SegFlags.REVIEW_PROGRESS_DASHBOARD,
			},
			{
				name: "navigation:project.tasks",
				to: `/projects/${projectId}/dashboard/tasks`,
				segFlag: [SegFlags.SMART_REVIEW, SegFlags.TASK],
			},
		],
	},
	{
		name: portfolioName,
		to: `/projects/${projectId}/project-synthesis`,
		segFlag: null,
		allowedEnvironments: ["veolia"],
	},
	{
		name: "navigation:project.search",
		to: `/projects/${projectId}/search/my-search`,
		flag: Flags.SEARCHCARD,
		segFlag: SegFlags.SMART_SEARCH,
	},
	{
		name: "navigation:project.review",
		subItems: [
			{
				name: "navigation:project.my-review",
				to: `/projects/${projectId}/review/my-review`,
				segFlag: [SegFlags.SMART_REVIEW, SegFlags.DOCUMENT_CENTER_READING],
			},
			{
				name: "navigation:project.my-review-criteria",
				to: `/projects/${projectId}/review/project-sheet`,
				segFlag: SegFlags.AI_CRITERIA_DETECTION,
			},
			{
				name: "navigation:project.notes",
				to: `/projects/${projectId}/review/notes`,
				segFlag: [SegFlags.AI_NOTE, SegFlags.SMART_REVIEW],
			},
			{
				name: "navigation:project.risk-analysis",
				to: `/projects/${projectId}/synthesis-by-category`,
				flag: Flags.SELECT_SYNTHESIS,
				segFlag: [SegFlags.CATEGORY, SegFlags.REVIEW_BY_CATEGORY],
			},
			{
				name: "navigation:project.project-requirements",
				to: `/projects/${projectId}/review/project-requirements`,
				flag: Flags.REQUIREMENT_MATRIX,
				segFlag: SegFlags.PROJECT_REQUIREMENTS,
			},
			{
				name: "navigation:project.children-requirements",
				to: `/projects/${projectId}/review/children-requirements`,
				flag: Flags.COVERAGE_PLUGIN,
				segFlag: SegFlags.DELIVERABLES,
			},
			{
				name: "navigation:common.commitment-tracking",
				to: `/projects/${projectId}/commitment-tracking/`,
				allowedEnvironments: ["veolia"],
				segFlag: SegFlags.COMMITMENT,
				flag: Flags.COMMITMENT,
				requiresCommitmentAccess: true,
			},
			{
				name: "navigation:project.verification-of-detections",
				to: `/projects/${projectId}/review/verification-of-detections`,
				flag: Flags.CONTROL,
				segFlag: SegFlags.VERIFICATION_OF_DETECTIONS,
				role: Permissions.PROJECT_LEADER,
				companyRole: [Permissions.PROJECT_LEADER, Permissions.PROJECT_MANAGER],
			},
		],
	},
	{
		name: "navigation:project.follow-up",
		subItems: [
			{
				name: "navigation:project.question-to-the-client",
				to: `/projects/${projectId}/follow-up/question-to-the-client`,
				flag: Flags.QA,
				segFlag: SegFlags.QUESTION_ANSWER,
			},
			{
				name: "navigation:project.deliverables",
				subItems: [
					{
						name: "navigation:project.deliverables-list",
						to: `/projects/${projectId}/deliverables/list`,
						flag: Flags.COVERAGE,
						segFlag: SegFlags.DELIVERABLES,
					},
					{
						name: "navigation:project.assign-to-deliverables",
						to: `/projects/${projectId}/follow-up/deliverables/assign-to-deliverables`,
						flag: Flags.COVERAGE,
						segFlag: SegFlags.DELIVERABLES,
					},
				],
			},
			{
				name: "navigation:project.project-norms",
				to: `/projects/${projectId}/follow-up/project-standards`,
				flag: Flags.NORMS,
				segFlag: SegFlags.NORMS,
			},
		],
	},
	{
		name: "navigation:project.chat-project",
		to: `/projects/${projectId}/chat-project`,
		isBeta: true,
		flag: Flags.PROJECT_CHAT,
		segFlag: [SegFlags.CHAT_PROJECT, SegFlags.DISABLED],
	},
	{
		name: "navigation:project.chat",
		to: `/projects/${projectId}/chat`,
		flag: Flags.PROJECT_CHAT,
		segFlag: SegFlags.CHAT_PROJECT,
	},
];
